import { render, staticRenderFns } from "./manual-add.vue?vue&type=template&id=1f9058a9&scoped=true&"
import script from "./manual-add.vue?vue&type=script&lang=js&"
export * from "./manual-add.vue?vue&type=script&lang=js&"
import style0 from "./manual-add.vue?vue&type=style&index=0&id=1f9058a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9058a9",
  null
  
)

export default component.exports